import { addPin } from 'containers/Login/loginSlice'
import useTranslation from 'hooks/useTranslation'
import Submit from 'components/inputs/Submit'
import Warehouse from 'components/Warehouse'
import { useDispatch } from 'react-redux'
import { userConfig } from 'rest/urls'
import Form from 'components/PinForm'
import { PATCH } from 'rest/request'
import { useState } from 'react'
import phone from './phone.png'

const PinSlide = ({ callback }) => {
  const [pin, setPin] = useState('')
  const [warning, setWarning] = useState(false)

  const dispatch = useDispatch()
  const { t } = useTranslation('newWarehouse')
  const validation = () => {
    if (pin.length === 4) {
      submit()
    } else {
      setWarning(true)
    }
  }

  const submit = async () => {
    try {
      const body = { new_pin: pin }
      const response = await PATCH(userConfig, { body })
      if (response?.result === 'ok') {
        dispatch(addPin())
        callback()

      } else {
        setPin('')
        setWarning(true)
      }

    } catch (error) {
      setWarning(true)
    }
  }

  return <>
    <i className='icon icon--logo s24' />

    <div className='slide__warehouses'>
      <div className='warehouse --left'>
        <Warehouse />
      </div>
      <div className='warehouse --right'>
        <Warehouse />
      </div>
      <img className='img--phone' alt='phones' src={phone} />
    </div>

    <div className='slide__title center'>
      <div className='--secFont'>{t('setPinForYourApp')}</div>
    </div>

    <Form
      clear={!pin}
      setValue={setPin}
      warning={warning}
      setWarning={setWarning} />

    <div className='slide__desc'>
      <div>{t('youWillBeAbleToUseItTo')}</div>
      <div>{t('logInToTheApp')}</div>
    </div>

    <div className='slide__buttons'>
      <button className='button --back' onClick={() => setPin('')}>
        <span>{t('clear')}</span>
      </button>

      <Submit text={t('next')} action={validation} />
    </div>
  </>
}

export default PinSlide